$(document).ready(function () {

    if ($('.medios-modal__slider-wrapper').length) {
        $('[data-modal="medios-modal"]').on('click', function () {
            $('.medios-modal__slider-wrapper').slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 700,
                arrows: false,
                dots: false,
                infinite: true,
                responsive: [
                    {
                        breakpoint: 769,
                        settings: {
                            variableWidth: true,
                            slidesToShow: 1
                        }
                    },
                    {
                        breakpoint: 577,
                        settings: {
                            centralMode: true,
                            slidesToShow: 1
                        }
                    }
                ]
            });
        });

    }

    $('[data-modal="medios-modal"]').on('click', function () {
        $(' #medios-modal').fadeIn('slow'); //при нажатии на кнопку появляется модальное окно
        document.body.classList.toggle('overflow-hidden');
    });
    $('.close').on('click', function () {
        $('#medios-modal').fadeOut('slow'); //при нажатии на крестик закзрываю блок
        document.body.classList.toggle('overflow-hidden');
    });

});